export const isValidBoardSize = (value: number, min: number, max: number) => {
  return !Number.isNaN(value) && value <= max && value >= min
}
